import {
  html,
  SYSBaseElement,
  TemplateResult,
} from "../../../../../_ovlclient/src"
import type { SYSTableDefIds } from "../../../../../_ovlclient/src"
import {
  DialogClose,
  DialogCurrent,
  DialogCurrentState,
  DialogOpen,
} from "../../../../../_ovlclient/src/library/dialog/dialogapi"
import type { DialogHolderParams } from "../../../../../_ovlclient/src/library/dialog/dialogapi"
import { T } from "../../../../../_ovlclient/src/textapi"
import {
  TableGet,
  TableRefresh,
} from "../../../../../_ovlclient/src/library/table/tableapi"
import { UserAdministration_UserType } from "../user/tabledef"
import { PermissionHas } from "../../../../../_ovlclient/src/global/globalapi"
import { NavDef } from "../../../../../_ovlclient/src/library/table/navcontrol"

export class DialogSYSUserAdministrationUserRole extends SYSBaseElement {
  async init() {
    this.dialog = "SYSUserAdministration_UserRole"
    await super.init()
  }
  async getUI() {
    let selectedUserTable = TableGet<UserAdministration_UserType>(
      "SYSUserAdministration_User",
      { byKeys: "SelectedTimeDesc" }
    )
    let selectedUser = selectedUserTable.rows[selectedUserTable.getKeys()[0]]
    let firstName = selectedUser.FirstName
    let lastName = selectedUser.LastName
    let userId = selectedUser.U_ITFPrtUserId
    let dialogHolderParams: DialogHolderParams
    let buttonTransferRole = html`<div></div>`
    if (PermissionHas("SYSUR", "M")) {
      buttonTransferRole = html`<button
        id="ua_transferuserrole"
        class="fd-button fd-button--compact"
        @click=${async (e) => {
          await TableRefresh("SYSUserAdministration_UserRoleTransfer", {
            resetStrategy: { Selection: true },
          })
          DialogOpen("SYSUserAdministration_UserRoleTransfer")
        }}
      >
        <span class="fd-button__text"
          >${T("SYSUserAdministrationUserRoleTransfer")}</span
        >
        <i class="sap-icon--copy"></i>
      </button>`
    }

    dialogHolderParams = {
      dialogParts: {
        tableDefButtonsInFooter: "SYSUserAdministration_UserRole",
        dismissedCallbackFn: () => {
          DialogClose(this.dialog)
        },
        title: () =>
          html`<div class="ua_userroletitle">
            <div>
              ${T("SYSUserAdministrationUserRoleTitle")}<br />
              ${firstName} ${lastName} (${userId})
            </div>
            <div></div>
            ${buttonTransferRole}
          </div>`,

        body: () => {
          let resultingPermissionsTable
          let permissionsOverview
          if (DialogCurrent() !== "SYSUserAdministration_Permission") {
            let cds = this.dialogState
            if (cds.data === undefined) {
              cds.data = {
                expanded: false,
              }
            }
            resultingPermissionsTable = html`<ovl-table
              class="fd-table fd-table--no-horizontal-borders fadeInControl"
              .props=${() =>
                <SYSTableDefIds>"SYSUserAdministration_ResultingPermission"}
            >
            </ovl-table>`
            permissionsOverview = html` <div class="fd-panel">
              <div class="fd-panel__header">
                <div class="fd-panel__expand">
                  <button
                    @click=${(e) => {
                      cds.data.expanded = !cds.data.expanded
                    }}
                    class="fd-button fd-button--transparent fd-panel__button"
                    aria-expanded="${cds.data.expanded}"
                    aria-haspopup="true"
                    aria-label="expand/collapse panel"
                    aria-controls="fghqwe321"
                  >
                    <i
                      class="sap-icon--slim-arrow-${cds.data.expanded
                        ? "down"
                        : "right"}"
                    ></i>
                  </button>
                </div>
                <h5
                  class="fd-panel__title ua_resultingpermissions_title"
                  id="asdASD123"
                >
                  ${T("SYSUserAdministrationResultingPermissionsTitle")}
                </h5>
              </div>
              <div
                role="region"
                aria-labelledby="jhqDKYdf"
                class="fd-panel__content"
                aria-hidden="${!cds.data.expanded}"
                id="fghqwe321"
              >
                <div class="fd-layout-panel__body">
                  ${resultingPermissionsTable}
                </div>
              </div>
            </div>`
          }

          return html`<ovl-table
              class="fd-table fd-table--no-horizontal-borders"
              .props=${() => <SYSTableDefIds>"SYSUserAdministration_UserRole"}
            >
            </ovl-table>
            ${permissionsOverview} `
        },
      },
      dialogType: this.dialog,
    }

    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
